module.exports = __webpack_public_path__ + "img/back-grey.54991a64.png";